<template>
  <div>

    <div class="sidebar-matches__buttons">
      <button
        v-on:click="showOnline=true" class="button button__tab"
        :class="{'button__tab--active': showOnline}"
      >{{ trans.get('left_side.bottom.online') }}
      </button>
      <button
        v-on:click="showOnline=false" class="button button__tab"
        :class="{'button__tab--active': !showOnline}"
      >{{ trans.get('left_side.bottom.matches') }}
      </button>
    </div>

    <hr>

    <div v-if="showOnline" class="sidebar-matches__main">
      <div class="sidebar-matches__profiles">
        <div v-for="profile in online" class="avatar-responsive-grid">
          <a href="#" v-on:click="openBuyModal(profile)" v-if="profile.is_blurred_avatar">
            <div
              class="avatar-single avatar-single--circle avatar-single--shadow avatar-single--hover-grow"
              v-bind:style="{ 'background-image': 'url(' + profile.avatar_url + '?p=tiny)' }"
            >
              <div v-if="profile.is_online" class="avatar-single__online-status"></div>
            </div>
          </a>
          <router-link v-else :to="{name: 'profile', params: {id: profile.id}}">
            <div
              class="avatar-single avatar-single--circle avatar-single--shadow avatar-single--hover-grow"
              v-bind:style="{ 'background-image': 'url(' + profile.avatar_url + '?p=tiny)' }"
            >
              <div v-if="profile.is_online" class="avatar-single__online-status"></div>
            </div>
          </router-link>
        </div>
      </div>

      <div v-if="online.length===0" class="info-box">
        <div class="info-box__icon"><i class="demo-icon icon-users"></i></div>
        <p class="info-box__title">{{ trans.get('left_side.bottom.no_results') }}</p>
      </div>

      <router-link :to="{name: 'members'}" class="button button__fill button--tight mt-3 mx-auto">
        {{ trans.get('left_side.bottom.show_all_button') }}
      </router-link>
    </div>

    <div v-if="!showOnline" class="sidebar-matches__main">
      <div class="sidebar-matches__profiles">
        <div v-for="profile in matches" class="avatar-responsive-grid">
          <router-link :to="{name: 'profile', params: {id: profile.id}}">
            <div
              class="avatar-single avatar-single--circle avatar-single--shadow avatar-single--hover-grow"
              v-bind:style="{ 'background-image': 'url(' + profile.avatar_url + '?p=tiny)' }"
            >
              <div v-if="profile.is_online" class="avatar-single__online-status"></div>
            </div>
          </router-link>
        </div>
      </div>

      <div v-if="matches.length===0" class="info-box">
        <div class="info-box__icon"><i class="demo-icon icon-users"></i></div>
        <p class="info-box__title">{{ trans.get('left_side.bottom.no_results') }}</p>
      </div>

      <router-link :to="{name: 'members'}" class="button button__fill button--tight mt-3 mx-auto">
        {{ trans.get('left_side.bottom.show_all_button') }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'OnlineCardComponent',
  components: {},
  data() {
    return {
      showOnline: true,
      buyProfileModal: {
        state: false,
        profileId: null,
        isOther: false,
      },
    };
  },
  computed: {
    ...mapGetters('profiles', {
      online: 'getOnline',
      matches: 'getMatches'
    }),
    profiles: function () {
      if (this.showOnline) {
        return this.online;
      } else {
        return this.matches;
      }
    }
  },
  methods: {
    openBuyModal: function (profile) {
      this.$eventHub.$emit('BuyProfileModalOpen', { profileId: profile.id, form: { distance: 500 }, avatarUrl: profile.avatar_url });
    },
  },
  mounted() {
    this.$store.dispatch('profiles/loadOnline');
    this.$store.dispatch('profiles/loadMatches');

    let vm = this;
    vm.$eventHub.$on('FreshProfile', (profile) => {
      vm.$store.commit('profiles/setOnlineProfile', profile);
    });
  }
};
</script>

<style scoped>

</style>
